<template>
  <div class="centered-container">
    <div class="centered-content">
      <v-progress-circular
        size="100"
        indeterminate
        color="gray"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { nonSaveCookie } from "@/store/cookie";

export default {
  async created() {
    const code = this.$route.query.code;

    sessionStorage.setItem("info2", atob(code));
    sessionStorage.setItem("chathess", true);

    setTimeout(() => {
      this.$router.push({ path: "/" });
    }, 500);
  },
};
</script>

<style>
.centered-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.centered-content {
  position: relative;
}
</style>